export const GET_MARKETFRUITS = "GET_MARKETFRUITS";
export const GET_MARKETFRUIT_UPDATE = "GET_MARKETFRUIT_UPDATE";
export const COPY_MARKETFRUIT = "COPY_MARKETFRUIT"
export const QUALITY_LIST = "QUALITY_LIST"
